export const toolsList = [
  {
    route: 'tools.ftp',
    category: 'power',
    color: 'text-purple-500',
    icon: 'power',
    path: '/tools/ftp-calculator',
    title: 'FTP Calculator',
    linkTitle: 'Cycling FTP Power Calculator',
    description: 'Estimate your FTP from a 20-minute, ramp, or 8-minute test and get your power zones.'
  },
  {
    route: 'tools.criticalPower',
    category: 'power',
    color: 'text-purple-500',
    icon: 'progress',
    path: '/tools/critical-power-calculator',
    title: 'Critical Power Calculator',
    linkTitle: 'Critical Power Calculator',
    description: 'Model your critical power and W′ from two or three maximal efforts.'
  },
  {
    route: 'tools.powerZones',
    category: 'power',
    color: 'text-purple-500',
    icon: 'zone-analysis',
    path: '/tools/power-training-zones-calculator',
    title: 'Power Zones Calculator',
    linkTitle: 'Cycling Power Training Zones Calculator',
    description: 'Turn your FTP into training zones with exact watt ranges.'
  },
  {
    route: 'tools.heartRateZones',
    category: 'heartRate',
    color: 'text-red-500',
    icon: 'heart',
    path: '/tools/heart-rate-zones-calculator',
    title: 'Heart Rate Zones Calculator',
    linkTitle: 'Cycling Heart Rate Zones Calculator',
    description: 'Build 5- or 7-zone heart rate models from max HR or LTHR.'
  },
  {
    route: 'tools.lactateThreshold',
    category: 'heartRate',
    color: 'text-red-500',
    icon: 'intensity',
    path: '/tools/lactate-threshold-calculator',
    title: 'Lactate Threshold Calculator',
    linkTitle: 'Lactate Threshold Calculator',
    description: 'Estimate your threshold heart rate and power from a field test.'
  },
  {
    route: 'tools.zone2Training',
    category: 'heartRate',
    color: 'text-red-500',
    icon: 'zone-analysis',
    path: '/tools/zone-2-calculator',
    title: 'Zone 2 Calculator',
    linkTitle: 'Zone 2 Training Calculator',
    description: 'Find your Zone 2 range for aerobic base training.'
  },
  {
    route: 'tools.vo2Max',
    category: 'fitness',
    color: 'text-green-500',
    icon: 'arrow-up-right',
    path: '/tools/vo2-max-calculator',
    title: 'VO2 Max Calculator',
    linkTitle: 'VO2 Max Calculator',
    description: 'Estimate your VO2 max from FTP or resting heart rate.'
  },
  {
    route: 'tools.goodFtp',
    category: 'power',
    color: 'text-purple-500',
    icon: 'medal',
    path: '/tools/how-good-is-my-ftp',
    title: 'What Is a Good FTP?',
    linkTitle: 'What Is a Good FTP',
    description: 'Compare your FTP and W/kg against rider categories, with FTP levels in watts.'
  },
  {
    route: 'tools.tss',
    category: 'load',
    color: 'text-blue-500',
    icon: 'battery',
    path: '/tools/tss-calculator',
    title: 'TSS Calculator',
    linkTitle: 'Cycling TSS Calculator',
    description: "Score a ride's training stress from duration, power, and FTP."
  },
  {
    route: 'tools.powerToWeight',
    category: 'power',
    color: 'text-purple-500',
    icon: 'sport-weight',
    path: '/tools/power-to-weight-calculator',
    title: 'Power to Weight Calculator',
    linkTitle: 'Power to Weight Calculator',
    description: 'Calculate your W/kg — the number that matters when the road tilts up.'
  },
  {
    route: 'tools.variabilityIndex',
    category: 'load',
    color: 'text-blue-500',
    icon: 'variability-index',
    path: '/tools/variability-index-calculator',
    title: 'Variability Index Calculator',
    linkTitle: 'Cycling Variability Index Calculator',
    description: 'Measure how smooth your pacing was.'
  },
  {
    route: 'tools.intensityFactor',
    category: 'load',
    color: 'text-blue-500',
    icon: 'intensity',
    path: '/tools/intensity-factor-calculator',
    title: 'Intensity Factor Calculator',
    linkTitle: 'Cycling Intensity Factor Calculator',
    description: 'See how hard a ride was relative to your threshold.'
  },
  {
    route: 'tools.runningPace',
    category: 'fitness',
    color: 'text-green-500',
    icon: 'running',
    path: '/tools/running-pace-calculator',
    title: 'Running Pace Calculator',
    linkTitle: 'Running Pace Calculator',
    description: 'Convert race goals into target paces and estimated finish times.'
  },
  {
    route: 'tools.calorieCalculator',
    category: 'fitness',
    color: 'text-green-500',
    icon: 'battery',
    path: '/tools/cycling-calorie-calculator',
    title: 'Cycling Calorie Calculator',
    linkTitle: 'Cycling Calorie Calculator',
    description: 'Calculate calories burned cycling from power data or speed and weight.'
  },
  {
    route: 'tools.raceTimePredictor',
    category: 'fitness',
    color: 'text-green-500',
    icon: 'running',
    path: '/tools/race-time-predictor',
    title: 'Race Time Predictor',
    linkTitle: 'Race Time Predictor',
    description: 'Predict your 5K to marathon times from any recent race result.'
  },
  {
    route: 'cyclingWorkouts',
    category: 'power',
    color: 'text-purple-500',
    icon: 'intensity',
    path: '/cycling-workouts',
    title: 'Cycling Workouts',
    linkTitle: 'Structured Cycling Workouts by Goal',
    description: '100+ structured workouts by goal and category, with indoor and outdoor instructions and free downloads.'
  },
  {
    route: 'tools.workoutBuilder',
    category: 'power',
    color: 'text-purple-500',
    icon: 'cycling',
    path: '/tools/workout-builder',
    title: 'Workout Builder',
    linkTitle: 'Free Cycling Workout Builder',
    description: 'Build structured intervals visually and export ZWO, ERG & MRC files — free, no login.'
  },
  {
    route: 'tools.zwiftImporter',
    category: 'power',
    color: 'text-purple-500',
    icon: 'cycling',
    path: '/tools/zwift-workout-importer',
    title: 'Zwift Workout Importer',
    linkTitle: 'Import Any Workout Into Zwift',
    description: 'Drop in a .zwo, .erg or .mrc file and import it straight into your Zwift custom workouts folder.'
  }
]
